<template>
  <div class="container">
    <div class="columns">
      <section class="column is-6">
        <header><LsSupportHeader label="Long Grass Dispute" /></header>
        <main>
          <h2>Your long grass dispute is submitted!</h2>
          <p>
            Our support team will review the Long Grass dispute and get back to you with the support
            decision.
          </p>
          <LsButton
            text="Back to my services"
            track-id="longgrass_dispute-back_button"
            test-id="back_dispute_button"
            bg-color="primary"
            text-color="white"
            @click="goToMyServices"
          />
        </main>
      </section>
    </div>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';
import { LsSupportHeader } from '@/views/Authorized/SupportView/components';

export default {
  name: 'LongGrassDisputeSuccess',
  components: { LsButton, LsSupportHeader },
  methods: {
    goToMyServices() {
      this.$router.push({ name: 'services' });
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  margin-bottom: 3rem;
}

h2 {
  font-size: 1.8rem;
  margin-bottom: 2rem;
}

p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
}
</style>
